import React, { useEffect, useState } from "react";
import {
  Box, Button, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogTitle, IconButton, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TextField, Typography
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Edit } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ManageCategories from "../ManageCategories/ManageCategories";

const ManageGuidesUser = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [guideName, setGuideName] = useState("");
  const [guideImage, setGuideImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formError, setFormError] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editingGuideId, setEditingGuideId] = useState(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [userType, setUserType] = useState("");
  const navigate = useNavigate();

  const fetchGuides = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/approvedGuides`);
      setGuides(res.data);
    } catch (err) {
      console.error("Error fetching guides:", err);
    } finally {
      setLoading(false);
    }
  };

  const getUsernamefromCookie = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, { withCredentials: true });
      if (res.data.username) {
        setUsername(res.data.username);
        setUserType(res.data.user);
        setIsLoggedIn(true);
      } else {
        navigate("/login");
      }
    } catch (err) {
      console.error("Login check error:", err);
      navigate("/login");
    }
  };

  useEffect(() => {
    fetchGuides();
    getUsernamefromCookie();
  }, []);



  return (
    <Box p={3}>
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>College Counseling Resources</strong></TableCell>
                <TableCell><strong>Pdf</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {guides.map((g) => (
                <TableRow key={g._id}>
                  <TableCell>{g.name}</TableCell>
                  <TableCell>
                    {g.eventImage ? (
                        g.eventImage.endsWith('.pdf') ? (
                            <a href={g.eventImage} target="_blank" rel="noopener noreferrer">
                            {g.name}
                            </a>
                        ) : (
                            <img
                            src={g.eventImage}
                            alt={g.name}
                            width={80}
                            height={60}
                            style={{ objectFit: "cover", borderRadius: "4px" }}
                            />
                        )
                        ) : "No file"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default ManageGuidesUser;
